<app-head-nav
  [isRestProfile]="isProfile"
  (selectedRestaurantId)="restaurantId = $event; GetScreenData();">
</app-head-nav>

<div class="form-page small-empty">
  <div class="form-content">
    <div class="row top-buttons mt-5 mb-3">
      <div class="col-md-6">
        <button mat-button class="cancel" (click)="openConfirmDialog()">{{'forms.Cancel' |
          translate}}</button>
      </div>
      <div class="col-md-6 ml-auto">
        <button mat-button class="continue" *ngIf="restaurantSize?.canAdd" (click)="saveRecord()">{{'forms.Save' |
          translate}}</button>
      </div>
    </div>
    <br>
    <div class="form-page">
      <div class="form-content">
        <div class="card">
          <div class="card-head pb-0">
            <div class="title">{{'sizes.Use BonTech Sizes' | translate}}</div>
          </div>
          <div *ngIf='loading' class="dataLoading py-5">
            <mat-spinner class="m-auto" diameter="50"></mat-spinner>
          </div>
          <div class="card-content pt-0" *ngIf='!loading'>

            <div class="table-responsive mt-3" *ngIf="sizesList.length; else dataEmpty">
              <table class="table-list">
                <thead>
                  <th>{{"sizes.Size" | translate}}</th>
                  <!-- <th class="text-right">{{"restaurant.Menu Unit" | translate}}</th> -->
                  <th></th>
                </thead>
                <tbody>

                  <tr *ngFor="let size of sizesList; index as index">
                    <td>
                      <div class="name-with-image squared">
                        <div class="name">
                          <h5>{{size.name}}</h5>
                        </div>
                      </div>
                    </td>
                    <td class="actions">
                      <div class="card-actions">
                        <button mat-icon-button (click)="removeSize(index, size)" *ngIf="size.restaurantsizeId">
                          <img src="./assets/images/icons/close.svg">
                        </button>
                        <button mat-icon-button (click)="removeSize(index)" *ngIf="!size.restaurantsizeId">
                          <img src="./assets/images/icons/close.svg">
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

            </div>

            <div>
              <button mat-button class="btn-light btn-small" mat-stroked-button (click)="openSizeForm()" *ngIf="restaurantSize?.canAdd">
                <img src="./assets/images/icons/plus-ic.svg">
                <span>{{"sizes.Add New Size" | translate}}</span>
              </button>
            </div>

          </div>

          <ng-template #dataEmpty>
            <empty-state [title]='"general.No Data Found" | translate'></empty-state>
          </ng-template>
        </div>
        <div class="card">
          <div class="card-head pb-3">
            <div class="title">{{'sizes.Use Custom Sizes' | translate}}</div>
          </div>
          <div *ngIf='loading' class="dataLoading py-5">
            <mat-spinner class="m-auto" diameter="50"></mat-spinner>
          </div>
          <div class="card-content pt-0" *ngIf='!loading'>

            <div class="table-responsive mt-3" *ngIf="customSizeList.length; else dataEmpty">
              <table class="table-list">
                <thead>
                  <th>{{"sizes.Size" | translate}}</th>
                  <th></th>
                </thead>
                <tbody>

                  <tr *ngFor="let size of customSizeList; index as index">
                    <td>
                      <div class="name-with-image squared">
                        <div class="name">
                          <h5>{{size.name.title_EN}}</h5>
                          <h5>{{size.name.title_AR}}</h5>
                        </div>
                      </div>
                    </td>

                    <td class="actions">
                      <div class="card-actions">
                        <button mat-icon-button (click)="openCustomForm(index)" *ngIf="restaurantSize?.canAdd">
                          <img src="./assets/images/icons/edit.svg" [matTooltip]="'general.Edit' | translate">
                        </button>
                        <button mat-icon-button (click)="removeCustomSize(index, size)"
                          [matTooltip]="'general.Delete' | translate" *ngIf="size.restaurantsizeId">
                          <img src="./assets/images/icons/close.svg">
                        </button>
                        <button mat-icon-button (click)="removeCustomSize(index)" *ngIf="!size.restaurantsizeId">
                          <img src="./assets/images/icons/close.svg">
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

            </div>

            <div>
              <button mat-button class="btn-light btn-small" mat-stroked-button (click)="openCustomForm()" *ngIf="restaurantSize?.canAdd">
                <img src="./assets/images/icons/plus-ic.svg">
                <span>{{"sizes.Add new Custom Sizes" | translate}}</span>
              </button>
            </div>

          </div>

          <ng-template #dataEmpty>
            <empty-state [title]='"general.No Data Found" | translate'></empty-state>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
